import { ComponentType } from 'react';
import { connect, MapDispatchToProps } from 'react-redux';
import { searchFriendsWithOptions } from '../redux/users/actionCreators';
import { Props } from './UserSearchField';

export type DispatchProps = Pick<Props, 'onSearch'>;
export type OwnProps = Omit<Props, keyof DispatchProps>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onSearch: searchFriendsWithOptions,
};

export default connect(null, mapDispatchToProps, null, {
  forwardRef: true,
}) as (component: ComponentType<Props>) => ComponentType<OwnProps>;
